import React from 'react'
import Scroll from 'react-scroll'
import ReactScrollLink from '../General/ReactScollLink'
import AmbientPicture from '../MovieInformation/AmbientPicture'
import MovieTimes from '../MovieInformation/MovieTimes'
import PerformancePage from './index'
import MovieTimesContainer from '../MovieInformation/MovieTimesContainer'

let Element = Scroll.Element


const PerformanceSection = ({
    itemID, 
    hideCinemaSelector, 
    isMobile,
    translation, 
    activePerformance, 
    filterType, 
    filterValue, 
    queryStringValues,
    moviesData, 
    theme,
    scrollToPosition, 
    overviewFilterIgnoreOnPerformances,
    backgroundImage,
    performancePageMovieTimes=false, 
    currentDateActive, 
    toggleMovieDatesOnMobileView, 
    informationStyling = '', 
    onOpenPerformancePage, 
    onClosePerformancePage, 
    activeCinema
}) => {
    if(!moviesData[itemID]) {
        return ''
    }


    if(!theme) {
        return ''
    }
    
    const movieData = moviesData[itemID]
    const { title, titleDisplay, technologyAttributes, origTitle } = movieData
    const { url, id, cinema } = activePerformance

    const containsOv = _.find(technologyAttributes, attribute => {
        return attribute.id === 'owefwefwweffv'
    })

    const currentTitle = titleDisplay ? titleDisplay : containsOv && origTitle ? origTitle : title 

    return (
        <Element name={scrollToPosition + ' movieInformation'}>
            <div className={'movie-information ' + theme.toLowerCase() + ' ' + informationStyling} id={'movie-performance'}>

                <div className="close-button-wrapper">
                    <ReactScrollLink to={scrollToPosition} offset={-200}>
                        <div className="close-button cursor-pointer" onClick={() => onClosePerformancePage({
                            timeUtc: activePerformance.timeUtc,
                            movieTitle: currentTitle
                        })}>
                              {isMobile ? (
                                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                    <polygon className="cls-1" points="13.73 30 14.83 28.99 2.71 15.74 30 15.74 30 14.24 2.71 14.24 14.82 1.01 13.71 0 0 14.99 13.73 30"/>
                                </svg>
                            ) : (
                                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                    <polygon className="cls-1" points="25 1.06 23.94 0 12.5 11.44 1.06 0 0 1.06 11.44 12.5 0 23.94 1.06 25 12.5 13.56 23.94 25 25 23.94 13.56 12.5 25 1.06"/>
                                </svg>
                            )}
                        </div>
                    </ReactScrollLink>
                </div>

                {theme !== 'Arthouse' && <AmbientPicture isMobile={isMobile} image={backgroundImage} />}

                <div className ={'movie-information-content-wrapper'}>
                    <div className={"movie-content performance-page-open"}>

                        <h2 className={'title title-xlarge-bold'}>{currentTitle}</h2>

                        <MovieTimesContainer 
                            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                            filterValue={filterValue}
                            filterType={filterType}
                            queryStringValues={queryStringValues}
                            performancePageMovieTimes={performancePageMovieTimes}
                            hideCinemaSelector={hideCinemaSelector}
                            movieData={movieData} 
                            activePerformance={activePerformance}
                            activeCinema={activeCinema}
                            onClick={toggleMovieDatesOnMobileView}
                            additionalClass={' show-on-mobile'}
                            currentDateActive={currentDateActive}
                            scrollToPosition={scrollToPosition}
                            onOpenIframe={onOpenPerformancePage}
                        />
                        <PerformancePage
                            deeplinkURL={url}
                            showId={id}
                            translation={translation}
                            scrollToPosition={scrollToPosition}
                            cinema={cinema}
                        />
                    </div>
                </div>
            </div>
        </Element>
    )

}


export default PerformanceSection